import { SxyCodeEditorController } from "../../controllers";
import { ComponentBase } from "../_ComponentBase";

/**
 * Code editor can be used in editing JSON, Schema and even JavaScript and HTML.
 * The system uses external code editor (https://code-editor.salaxy.com / https://test-code-editor.salaxy.com) if available or falls back to textarea when not available.
 * @example
 * ```html
 * <sxy-code-editor ng-model="$ctrl.currentSchema" lang="json"></sxy-code-editor>
 * ```
 */
export class SxyCodeEditor extends ComponentBase {

  /** Components contents can be used to set the initial code. */
  public transclude = true;

  /** ng-model may be used to binding the code to a string in an object. */
  public require = {
    model: "?ngModel",
  };

  /**
   * The following component properties (attributes in HTML) are bound to the Controller.
   * For detailed functionality, refer to [controller](#controller) implementation.
   */
  public bindings = {
    /** Type of user interface to render: "monaco" (default) or "basic" HTML (textarea/pre) */
    mode: "@",
    /** If true, the component is read-only */
    readOnly: "<",
    /**
     * Language of the code, e.g. "javascript" (default), "html", "json" or "css".
     * Currently only affects the Monaco editor.
     */
    lang: "@",

    /**
     * Type of the main object that is called "item" in the code.
     * Type should be one of @salaxy/core types (e.g. "Calculation") or supported
     * native types (currently ["any", "string", "[]"]). Default is any.
     */
    itemType: "<",

    /** The height of the editor as CSS, (e.g. "calc(100vh - 600px)"). Default is "400px" */
    height: "@",
    /**
     * Type of the editor to use: "monaco" (default), "sample" or "formula".
     */
    editor: "@"
  };

  /** Uses the SxyInputController */
  public controller = SxyCodeEditorController;

  /** The default template for the component. */
  public defaultTemplate = "salaxy-components/sxy-form/SxyCodeEditor.html";
}
